import { render, staticRenderFns } from "./selfSign.vue?vue&type=template&id=0a4aec11"
import script from "./selfSign.vue?vue&type=script&lang=js"
export * from "./selfSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports